import React, { useMemo } from "react";

import { MultiSelect } from "../../common/MultiSelect";
import * as styles from "./index.scss";

export interface IFilterSelector {
    value: string[] | undefined;
    keys: string[];
    onChange: (value: string[], context?: string) => void;
}

export function FilterSelector(props: IFilterSelector) {
    const { value = [], keys, onChange } = props;
    const options = useMemo(
        () => keys.map(_ => ({ value: _, label: _ })),
        [keys],
    );

    if (keys.length === 0) {
        return null;
    }

    return (
        <MultiSelect
            value={value}
            options={options}
            title="Filter"
            onChange={onChange}
            className={styles.filterSelector}
            menuStyle="black"
        />
    );
}
